import LocalStorage from '../data/local-storage';

class ThemeService {
  constructor() {
    this.currentTheme = 'light';
    this.currentFont = 'default';
  }

  load() {
    this.currentTheme = LocalStorage.getItem('heliaedu_theme') || 'light';
    this.currentFont = LocalStorage.getItem('heliaedu_font') || 'default';
  }

  apply() {
    this.updateTheme(this.currentTheme);
    this.updateFont(this.currentFont);
  }

  setTheme(theme) {
    this.currentTheme = theme;
    LocalStorage.setItem('heliaedu_theme', theme);
    this.updateTheme(theme);
  }

  setFont(font) {
    this.currentFont = font;
    LocalStorage.setItem('heliaedu_font', font);
    this.updateFont(font);
  }

  updateTheme(theme) {
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(theme);
    document.querySelectorAll('.theme-selector').forEach(el => el.classList.remove('active'));
    document.querySelectorAll(`.theme-selector[data-theme="${theme}"]`).forEach(el => el.classList.add('active'));
    document.querySelectorAll('.setting-option[data-theme]').forEach(el => el.classList.remove('active'));
    document.querySelectorAll(`.setting-option[data-theme="${theme}"]`).forEach(el => el.classList.add('active'));
  }

  updateFont(font) {
    document.body.classList.toggle('disleksia', font === 'disleksia');
    document.querySelectorAll('.font-selector').forEach(el => el.classList.remove('active'));
    document.querySelectorAll(`.font-selector[data-font="${font}"]`).forEach(el => el.classList.add('active'));
    document.querySelectorAll('.setting-option[data-font]').forEach(el => el.classList.remove('active'));
    document.querySelectorAll(`.setting-option[data-font="${font}"]`).forEach(el => el.classList.add('active'));
  }
}

export default new ThemeService();
